import { Entity } from '@/modules/common/domain/entity'
import CompanyBranch from '@/modules/company/domain/companyBranch'

class CashBox extends Entity {
  name?: string
  companyBranch: CompanyBranch | null
  acceptCash?: boolean
  acceptCheque?: boolean
  acceptCard?: boolean
  active?: boolean

  constructor (data: any) {
    super(data, 'id', 'name')

    this.companyBranch = data.companyBranch == null ? null : new CompanyBranch(data.companyBranch)
  }
}

export default CashBox
